<template>
    <div>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import { getCookie } from '@/utils';

    export default {
        name: 'RedirectPage',
        data() {
            return {

            }
        },
        mounted() {
            // 人事问卷
            const taskId = this.$route.query.taskId
            if (taskId && taskId != 'null' && taskId != 'undefined') {
                request({
                    url: "/my/getUserLogin",
                    m1ethod: "get",
                }).then((res) => {
                    if (res.code === 0) {
                        this.toQue(res.data.selfEmpNo)
                        return
                    }
                    this.$toast(res.msg + '')
                })
                return
            }
            // 质检问卷
            const empNo = localStorage.getItem("empNo") || getCookie("empNo")
            if (empNo) {
                this.toQue(empNo)
                return
            }
            request({
                url: "/my/getUserLogin",
                method: "get",
            }).then((res) => {
                if (res.code === 0) {
                    this.toQue(res.data.empNo)
                    return
                }
                this.$toast(res.msg + '')
            })
        },
        methods: {
            // 跳问卷
            toQue(empNo) {
                const { storeNo, questionId, qrCode, taskId } = this.$route.query
                // const questionId = 'C-d5oJoBUKCKEBMjyG7d' // 测试问卷
                const url = window.SITE_CONFIG['webviewUrl'] + '/quesBefore?' +
                    'questionId=' + questionId +
                    '&empNo=' + empNo +
                    (storeNo ? '&storeNo=' + storeNo : '') +
                    (qrCode ? '&qrCode=' + qrCode : '') +
                    (taskId ? '&taskId=' + taskId : '') +
                    '&brandName=beautyfarm&accountNo=1'

                // 防止yellow网站劫持
                if (url.includes(window.SITE_CONFIG['webviewUrl'])) {
                    window.location.replace(url)
                } else {
                    this.$toast('跳转链接被篡改，拦截')
                }
            }
        }
    }
</script>

<style lang='less' scoped></style>
